import Vue from 'vue'
import VueI18n from 'vue-i18n'
import zh from './locales/zh.json'
import en from './locales/en.json'
import pt from './locales/pt.json'
Vue.use(VueI18n);
// 从 localStorage 读取语言设置，如果没有则使用默认语言 'zh'
const locale = localStorage.getItem('language') || 'zh';

const i18n = new VueI18n({
  locale: locale, // 默认语言
  fallbackLocale: 'zh', // 回退语言
  messages: {
    zh,
    en,
    pt
  }
})

export default i18n